import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

export class _AjusteSpedStore {

  obs = observable({
    ajustes: [],
    ajustes_filter: "",
    ajustes_current: 1,
    ajustes_length: 0,

  })

  async ajustes_all(uf) {

    try {

      let resp = await api.get(`/api/ajustes/index-all/${uf}`)

      this.obs.ajustes = []

      if (resp.data.length > 0) {

        this.obs.ajustes = resp.data

      }

    } catch (ex) { }

  }

  async handleBuscaAjustes(page: number, text: string) {

    let params = {
      page: page,
      limit: 50,
      text: text
    }
    try {
      let resp = await api_adm.post('/api/admin/ajustes/index', params)

      this.obs.ajustes_length = 0
      this.obs.ajustes = []

      if (resp.data.itens.length > 0) {
        this.obs.ajustes = resp.data.itens
        this.obs.ajustes_length = resp.data.count
      }

    } catch (ex) { }

  }

  async handleCreateAjustes(params: any) {

    try {

      let resp = await api_adm.post('/api/admin/ajustes/create', params)

      if (resp.data.ok == true) {

        toast.success('Ajuste criado com sucesso.', {});

        this.obs.ajustes_current = 1
        await this.handleBuscaAjustes(1, this.obs.ajustes_filter)

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }

  async handleUpdateAjustes(params: any) {

    try {

      let resp = await api_adm.post('/api/admin/ajustes/update', params)

      if (resp.data.ok == true) {

        toast.success('Ajuste atualizado com sucesso.', {});

        this.obs.ajustes_current = 1
        await this.handleBuscaAjustes(1, this.obs.ajustes_filter)

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }

  async handleDeleteAjuste(id: string) {

    try {

      let resp = await api_adm.delete(`/api/admin/ajustes/${id}`)

      if (resp.data.ok == true) {

        toast.success('Ajuste deletado com sucesso.', {});

        this.obs.ajustes_current = 1
        await this.handleBuscaAjustes(1, this.obs.ajustes_filter)

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }

}

export const AjusteSpedStore = new _AjusteSpedStore();
